import { apiSlice } from "./ApiSlice";

const loginApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({

            query: credentials => {
              
                return {
                    url: '/api/Account/signin',
                    method: 'POST',
                    body: { ...credentials }
                }
            }
        }),

        sendOtp:  builder.mutation({
            query: email => {
                return {
                    url: `/api/Account/ForgetPassword?EmailID=${email}`,
                    method: 'POST',
                }
            }
        }),

        verifyOtp:  builder.mutation({
            query: formData => {
                return {
                    url: '/api/Account/otp_verifications',
                    method: 'POST',
                    body: formData
                }
            }
        }),

        resetPassword:  builder.mutation({
            query: formData => {
                return {
                    url: '/api/Account/update_password',
                    method: 'POST',
                    body: formData
                }
            }
        }),
    })
})

export const { useLoginMutation, useSendOtpMutation, useVerifyOtpMutation, useResetPasswordMutation } = loginApiSlice;